import { useMemo } from 'react';

import { useGetPropertyTicketTypeAvailableDates } from '../../../../../../../api/property/ticket-type/available-dates';

export const useTicketAvailableDates = ({
  propertyId,
  ticketTypeId,
}: {
  propertyId: string;
  ticketTypeId: string;
  singleKey?: string;
}) => {
  const { data: dataGetPropertyTicketTypeAvailableDates } =
    useGetPropertyTicketTypeAvailableDates({
      propertyId,
      ticketTypeId,
    });

  const availableDatesMap = useMemo<Map<string, string[]>>(() => {
    const r = new Map();
    // `default` is the union of every container's available dates, used as a
    // fallback when a selected container has no per-`container_id` entry (e.g.
    // when the backend omits container ids — BEACON-14). Building a union (not
    // last-write-wins) avoids offering one container's dates for another.
    const union = new Set<string>();
    dataGetPropertyTicketTypeAvailableDates?.data?.dates?.forEach(
      ({ dates, container_id }: $TSFixMe) => {
        if (container_id) r.set(container_id, dates);
        (dates ?? []).forEach((d: string) => union.add(d));
      }
    );
    if (union.size) r.set('default', [...union]);
    return r;
  }, [dataGetPropertyTicketTypeAvailableDates?.data?.dates]);

  return availableDatesMap;
};
